import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import HeaderProfile from "./HeaderProfile";
import ReactPlayer from "react-player";
import { ProfileContext } from "../../context/ContextProfile";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import DOMPurify from "dompurify";
import { API_BASE, webApiHeaders } from "../../apiConfig";
import "react-image-gallery/styles/css/image-gallery.css";

function SingleImage() {
  const { modifyVillage, selectedImage, modifySelectedImage } =
    useContext(ProfileContext);

  const [isGallery, setIsGallery] = useState(true);
  const [slideImages, setSlideImages] = useState(false);
  const navigate = useNavigate(); // Use useNavigate from React Router v6

  useEffect(() => {
    if (!selectedImage.path) {
      const urlPath = window.location.pathname;
      const segments = urlPath.split("/");
      const yourSegment = segments[2]; // Assuming the segment is always in this position
      const sanitizedSegment = DOMPurify.sanitize(yourSegment);

      // Direct link to /images/<name>: resolve the picture and its village.
      // (It used to call a route on the retired api.aldealista.com host that
      // no longer exists, so these links always bounced to the home page.)
      axios({
        method: "get",
        url: `${API_BASE}/v2/web/picture`,
        headers: webApiHeaders,
        params: {
          name: sanitizedSegment,
        },
      })
        .then((res) => {
          if (res.data.errorCode !== 0) {
            navigate("/"); // Use navigate to redirect
          }
          modifyVillage(res.data);
          modifySelectedImage(res.data.currentPicture);
        })
        .catch((error) => {
          console.error("Error fetching content:", error);
          navigate("/"); // Redirect to the home page on error
        });
      return;
    }

    if (selectedImage.isVideo === 1) {
      setSlideImages([]);
      return;
    }

    const preSlide = selectedImage.path.map((imgPath) => ({
      original: `https://aldealista.com/p/${imgPath}`,
      thumbnail: `https://aldealista.com/p/${imgPath}`,
      caption: "",
    }));

    setSlideImages(preSlide);
  }, [selectedImage, navigate, modifyVillage, modifySelectedImage]);

  return (
    <>
      {slideImages && selectedImage.path && (
        <div className="slide-container">
          <HeaderProfile />
          {selectedImage.isVideo === 0 ? (
            <Row style={{ margin: 0 }}>
              <Col xs={12} style={{ padding: 0 }}>
                <div className="container-borders">
                  {isGallery ? (
                    <ImageGallery
                      showPlayButton={false}
                      items={slideImages}
                      showThumbnails={false}
                      autoPlay={false}
                      className="container-borders"
                      lazyLoad={true}
                      showFullscreenButton={false}
                    />
                  ) : (
                    <img
                      src={`https://aldealista.com/p/${selectedImage.path[0]}`}
                      alt="."
                      className="main-image"
                      style={{ width: "100%", height: "auto" }}
                    />
                  )}
                </div>
              </Col>
            </Row>
          ) : (
            <Row style={{ margin: 0 }}>
              <Col xs={12} style={{ padding: 0 }}>
                <div className="container-borders">
                  <div className="player-wrapper">
                    <ReactPlayer
                      className="react-player"
                      url={selectedImage.path[0]}
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <Row className="description-row">
            <Col xs={12}>
              <p className="description">
                <span className="description-title">{selectedImage.title}</span>
              </p>
            </Col>
          </Row>

          {selectedImage.description && (
            <Row className="description-row">
              <Col xs={12}>
                <p className="description">{selectedImage.description}</p>
              </Col>
            </Row>
          )}

          {selectedImage.url1 && (
            <Row className="description-row">
              <Col xs={12}>
                <p className="description">
                  <a
                    href={selectedImage.url1}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectedImage.url1}
                  </a>
                </p>
              </Col>
            </Row>
          )}

          {selectedImage.url2 && (
            <Row className="description-row">
              <Col xs={12}>
                <p className="description">
                  <a
                    href={selectedImage.url2}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectedImage.url2}
                  </a>
                </p>
              </Col>
            </Row>
          )}

          {selectedImage.url3 && (
            <Row className="description-row">
              <Col xs={12}>
                <p className="description">
                  <a
                    href={selectedImage.url3}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectedImage.url3}
                  </a>
                </p>
              </Col>
            </Row>
          )}
        </div>
      )}
    </>
  );
}

export default SingleImage;
